export const messages = {
  en: {
    roleStaff: {
      title: 'Staff Association',
      staffId: 'Staff ID',
      staffName: 'Staff Name',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      gender: 'Gender',
      operation: 'Operation',
      addStaff: 'Associate Staff',
      deleteStaff: 'Remove Staff',
      detail: 'Details',
      searchPlaceholder: 'Enter staff name',
      confirmDelete: 'Are you sure to remove this staff?',
      selectStaffTip: 'Please select staff',
      addSuccess: 'Staff associated successfully',
      deleteSuccess: 'Staff removed successfully',
      male: 'Male',
      female: 'Female'
    }
  },
  zh: {
    roleStaff: {
      title: '员工关联',
      staffId: '员工编号',
      staffName: '员工姓名',
      phone: '手机号',
      email: '邮箱',
      address: '地址',
      gender: '性别',
      operation: '操作',
      addStaff: '关联员工',
      deleteStaff: '移除员工',
      detail: '详情',
      searchPlaceholder: '输入员工姓名',
      confirmDelete: '确定要移除该员工吗？',
      selectStaffTip: '请选择员工',
      addSuccess: '员工关联成功',
      deleteSuccess: '员工移除成功',
      male: '男',
      female: '女'
    }
  }
}